// extracted by mini-css-extract-plugin
export default {"container":"ImageTextRow_container__nEMSv","subContainer":"ImageTextRow_subContainer__mIszS"};